import { useMutation } from '@tanstack/react-query';

import { useSession } from '@/entities/session';
import { useTRPC } from '@/shared/api';

/** 서버가 받는 온보딩 답. 화면의 두 칸(`topTimeSink`·기타)은 한 값으로 합쳐서 보낸다. */
export interface OnboardingAnswers {
  name: string;
  jobRole: string;
  jobRoleTag: string;
  topTimeTask: string;
  automationLevel: string;
}

/**
 * 온보딩 저장.
 *
 * **세션 반영은 서버 응답으로만 한다.** 화면이 보낸 값을 그대로 스토어에 넣으면
 * 저장이 실패한 경우에도 닉네임이 바뀐 것처럼 보이고, 새로고침 한 번에 되돌아간다.
 * 온보딩 값이 브라우저에만 남던 것이 이 작업 전의 상태였다.
 *
 * 실패를 삼키지 않는다 — 사용자가 다시 눌러야 하는 자리이고, 조용히 넘기면
 * "다 채웠는데 마이페이지에는 안 보인다"가 된다. 문구는 화면이 정한다.
 */
export function useCompleteOnboarding(): (answers: OnboardingAnswers) => Promise<void> {
  const trpc = useTRPC();
  const applyOnboarding = useSession((state) => state.applyOnboarding);
  const { mutateAsync } = useMutation(trpc.auth.completeOnboarding.mutationOptions());

  return async (answers) => {
    // 결과는 `mutateAsync` 의 약속으로 받는다 — 뮤테이션 상태는 구독을 거쳐 오고,
    //   그 구독이 끊겼다 붙는 틈에 끝난 결과를 놓치는 자리가 있다.
    const member = await mutateAsync(answers);
    applyOnboarding(member);
  };
}
